import React from "react";
import ct from "class-types.macro";
import Carousel, { Item } from "../../common/Carousel";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { RelatedCategoriesResult } from "~/common/Store/models/Category";
import("./relatedCarouselStyles.scss");
interface Props {
  relatedCategories: RelatedCategoriesResult[];
}
const RelatedCarousel = ({
  relatedCategories
}: Props) => {
  return <Carousel data-sentry-element="Carousel" data-sentry-component="RelatedCarousel" data-sentry-source-file="RelatedCarousel.tsx">
      {relatedCategories.map(category => <Item sliderRight key={category.id}>
          <>
            <div className={ct("border-transparent", "group-hover:border-gray-200", "border-solid", "border", "flex-shrink-0", "p-1")}>
              <NoScriptLazyImage alt="" role="presentation" src={category.image.small} className="category_image" data-src={category.image.small} />
            </div>
            <div className={ct("mt-2", "max-w-xs", "text-center", "h-9")}>
              <a className={`link-pseudo ${ct("font-semibold", "text-xs", "leading-none", "break-words")}`} title={category.name} href={category.link} data-testid="categoryLink" data-label={category.id} data-action="click">
                {category.name}
              </a>
            </div>
          </>
        </Item>)}
    </Carousel>;
};
export default RelatedCarousel;